

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Checklist from 'vux/src/components/checklist/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Search from 'vux/src/components/search/index.vue'


import './plugins';

Vue.use(VueRouter)

Vue.component('x-header', XHeader)
Vue.component('x-img', XImg)
Vue.component('popup', Popup)
Vue.component('popup-header', PopupHeader)
Vue.component('group', Group)
Vue.component('x-input', XInput);
Vue.component('cell', Cell);
Vue.component('selector', Selector);
Vue.component('popupPicker', PopupPicker);
Vue.component('datetime', Datetime);
Vue.component('x-number', XNumber);
Vue.component('x-address', XAddress);
Vue.component('x-textarea', XTextarea);
Vue.component('x-switch', XSwitch);
Vue.component('x-button', XButton);
Vue.component('toast', Toast);
Vue.component('alertModule', AlertModule);
Vue.component('checklist', Checklist);
Vue.component('checker', Checker);
Vue.component('checkerItem', CheckerItem);
Vue.component('confirm', Confirm);
Vue.component('divider', Divider);
Vue.component('chinaAddressData', ChinaAddressData);
Vue.component('form-preview', FormPreview);
Vue.component('panel', Panel);
Vue.component('tab', Tab);
Vue.component('tab-item', TabItem);
Vue.component('sticky', Sticky);
Vue.component('msg', Msg);
Vue.component('card', Card);
Vue.component('swiper', Swiper);
Vue.component('swiper-item', SwiperItem);
Vue.component('actionsheet', Actionsheet);
Vue.component('load-more', LoadMore);
Vue.component('scroller', Scroller);
Vue.component('search', Search)

Vue.directive('transfer-dom', TransferDom);

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js